class InfiniteScroll {
  constructor() {
    this.loading = false;
    this.finished = false;
    this.observer = null;

    this.init();

    document.addEventListener("shopify:section:load", () => {
      this.reset();
    });

    document.addEventListener("facets:updated", () => {
      this.reset();
    });
  }

  init() {
    this.observe();
  }

  reset() {
    this.loading = false;
    this.finished = false;

    if (this.observer) {
      this.observer.disconnect();
    }

    setTimeout(() => {
      this.observe();
    }, 300);
  }

  getNextLink() {
    return document.querySelector('a[aria-label="Next page"]');
  }

  observe() {
    const nextLink = this.getNextLink();

    if (!nextLink) {
      this.finished = true;
      console.log("No more pages.");
      return;
    }

    if (this.observer) {
      this.observer.disconnect();
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.loading) {
          this.loadMore();
        }
      },
      {
        rootMargin: "300px"
      }
    );

    this.observer.observe(nextLink);
  }

  async loadMore() {
    if (this.loading || this.finished) return;

    const nextLink = this.getNextLink();

    if (!nextLink) {
      this.finished = true;
      return;
    }

    this.loading = true;

    // console.log("Loading:", nextLink.href);

    try {
      const response = await fetch(nextLink.href, {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Get new products
      const newItems = doc.querySelectorAll("#product-grid .grid__item");

      if (!newItems.length) {
        this.finished = true;
        return;
      }

      const grid = document.querySelector("#product-grid");

      newItems.forEach((item) => {
        grid.appendChild(item);
      });

      // Replace pagination
      const currentPagination = document.querySelector(".pagination-wrapper");
      const newPagination = doc.querySelector(".pagination-wrapper");

      if (currentPagination && newPagination) {
        currentPagination.innerHTML = newPagination.innerHTML;
      } else if (currentPagination) {
        currentPagination.remove();
        this.finished = true;
      }

      this.loading = false;

      this.observe();

    } catch (error) {
      console.error("Infinite Scroll Error:", error);
      this.loading = false;
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new InfiniteScroll();
});